// Email exceptions
export class EmailRequiredException extends Error {
  constructor() {
    super('auth-error-email-required');

    this.name = 'EmailRequiredException';
  }
}

export class EmailInvalidException extends Error {
  constructor() {
    super('auth-error-email-invalid');

    this.name = 'EmailInvalidException';
  }
}

// Password exceptions
export class PasswordRequiredException extends Error {
  constructor() {
    super('auth-error-password-required');

    this.name = 'PasswordRequiredException';
  }
}

export class PasswordTooShortException extends Error {
  constructor() {
    super('auth-error-password-too-short');

    this.name = 'PasswordTooShortException';
  }
}

export class PasswordMissingUppercaseException extends Error {
  constructor() {
    super('auth-error-password-missing-uppercase');

    this.name = 'PasswordMissingUppercaseException';
  }
}

export class PasswordMissingLowercaseException extends Error {
  constructor() {
    super('auth-error-password-missing-lowercase');

    this.name = 'PasswordMissingLowercaseException';
  }
}

export class PasswordMissingNumberException extends Error {
  constructor() {
    super('auth-error-password-missing-number');

    this.name = 'PasswordMissingNumberException';
  }
}

export class PasswordMissingSpecialCharException extends Error {
  constructor() {
    super('auth-error-password-missing-special-char');

    this.name = 'PasswordMissingSpecialCharException';
  }
}

// Confirm Password exceptions
export class ConfirmPasswordRequiredException extends Error {
  constructor() {
    super('auth-error-confirm-password-required');

    this.name = 'ConfirmPasswordRequiredException';
  }
}

export class PasswordMismatchException extends Error {
  constructor() {
    super('auth-error-password-mismatch');

    this.name = 'PasswordMismatchException';
  }
}

// Name exceptions
export class GivenNameRequiredException extends Error {
  constructor() {
    super('auth-error-given-name-required');

    this.name = 'GivenNameRequiredException';
  }
}

export class GivenNameLatinOnlyException extends Error {
  constructor() {
    super('auth-error-given-name-latin-only');

    this.name = 'GivenNameLatinOnlyException';
  }
}

export class FamilyNameRequiredException extends Error {
  constructor() {
    super('auth-error-family-name-required');

    this.name = 'FamilyNameRequiredException';
  }
}

export class FamilyNameLatinOnlyException extends Error {
  constructor() {
    super('auth-error-family-name-latin-only');

    this.name = 'FamilyNameLatinOnlyException';
  }
}

// Verification code exceptions
export class VerificationCodeRequiredException extends Error {
  constructor() {
    super('auth-error-verification-code-required');

    this.name = 'VerificationCodeRequiredException';
  }
}

export class VerificationCodeInvalidException extends Error {
  constructor() {
    super('auth-error-verification-code-invalid');

    this.name = 'VerificationCodeInvalidException';
  }
}

// New password exceptions
export class NewPasswordRequiredException extends Error {
  constructor() {
    super('auth-error-new-password-required');

    this.name = 'NewPasswordRequiredException';
  }
}

export class NewPasswordTooShortException extends Error {
  constructor() {
    super('auth-error-new-password-too-short');

    this.name = 'NewPasswordTooShortException';
  }
}

// Phone exceptions
export class PhoneRequiredException extends Error {
  constructor() {
    super('auth-error-phone-required');

    this.name = 'PhoneRequiredException';
  }
}

export class PhoneInvalidException extends Error {
  constructor() {
    super('auth-error-phone-invalid');

    this.name = 'PhoneInvalidException';
  }
}

// Terms agreement exceptions
export class AgreedToTermsRequiredException extends Error {
  constructor() {
    super('register-terms-required');

    this.name = 'AgreedToTermsRequiredException';
  }
}
